/**
 * Created by mark on 22/02/2018.
 */


import React from 'react';
import CatalogService from '../services/content-service.js';
import {Col , Row} from 'react-bootstrap';
import $ from 'jquery';
import Config from '../classes/config.js';
import Translation from '../store/internationalization-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import Table from './general_table.js';

export default class AnswerReport extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {};
        this.cdn = Config.getAudioBaseUrl() ;
        if (!props.type == "exam")  {
            this.props = props;
            this.setState({update: true});
        } else {
            if(this.props.data[0] != undefined && this.props.data[0].exam_question_uid != undefined 
                && (!this.state.examQuestion || (this.props.data[0].exam_question_uid != props.data[0].exam_question_uid))) {
                this.props = props;
                this.getExamData();
            }
        }
    }

    getExamData() {
        CatalogService.getExamQuestion(this.props.gameUID , this.props.data[0].exam_question_uid,
                'en-GB' , this.props.language , this.props.gameUID).then(function(response){
            this.setState({examQuestion:response});
        }.bind(this));
    }

    componentWillReceiveProps(props) {
        if (!props.type == "exam")  {
            this.props = props;
            this.setState({update: true});
        } else {
            if(this.props.data[0] != undefined && this.props.data[0].exam_question_uid != undefined 
                && (!this.state.examQuestion || (this.props.data[0].exam_question_uid != props.data[0].exam_question_uid))) {
                this.props = props;
                this.getExamData();
            }
        }

    }

    tickbox(cell){

        if(cell == '1')
        {
            return <center><i style={{color:'rgb(136, 192, 87)'}} class="fas fa-check"></i></center>
        }
        else
        {
            return <center><i  style={{color:'rgb(237, 113, 97)'}} class="fas fa-times"></i></center>
        }

    }


    render(){

        if(!this.props) return null;
        if(!this.props.data) return null;

        if(this.props.type == "vocab" || this.props.type == "verbs" || this.props.type == "sentence" || this.props.type == "grammar")
        {

            var getHeader = function(type){

                switch(type)
                {
                    case "verbs" : return  Translation.get(1028 , 'Verb');
                    case "sentence" : return  Translation.get(12218 , 'Sentence');
                    case "grammar" : return  Translation.get(100 , 'Grammar');
                    default : return  Translation.get(227 , 'Word');
                }

            }

            const columns = [
                {
                    dataField: 'translation',
                    text: getHeader(this.props.type),
                    align: "left",
                },
                {
                    dataField: 'is_correct',
                    text: Translation.get(275 , 'Correct'),
                    headerAlign: "center",
                    formatter:this.tickbox.bind(this),
                }
            ];

            return <Table hideDownload={true} hideSearch={true} data={  this.props.data || [] } columns={ columns }  bordered={ true } />
        }




        var findExamAnswer = function(questionUID){

            for(var idx = 0 ; idx < this.props.data.length; idx++){

                if(questionUID == this.props.data[idx].exam_question_sub_uid) return this.props.data[idx].is_correct
            }

            return "0"

        }.bind(this)

        if(this.props.type == "exam")
        {
            if(!this.state.examQuestion) return null;

            if(this.props.gameUID == "200" ||  this.props.gameUID == "201")
            {

                var questions = this.state.examQuestion.examTranslations;

                var data  = [];

                for(var idx = 0 ; idx < questions.length; idx++)
                {

                    var question = questions[idx];
                    var xmlDoc = $.parseXML(question.other);

                    var questionText = String($( xmlDoc ).find('question').text());

                    data.push({
                        translation:questionText,
                        is_correct:findExamAnswer(question.uid)
                    });
                }

                return <div>
                            <Row>
                                <Col md={12}>
                                    <div className="p-10 m-b-20" >{this.state.examQuestion.examDataOriginal.text}</div>
                                </Col>
                            </Row>
                            <BootstrapTable data={ data || []} keyField='uid'  bordered={ true } condensed>
                                <TableHeaderColumn dataField='translation' >Question</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.tickbox.bind(this)} dataField='is_correct' >Correct</TableHeaderColumn>
                            </BootstrapTable>
                       </div>
            }

            if(this.props.gameUID == "202" || this.props.gameUID == "204")
            {

                var questions = this.state.examQuestion.examTranslations;

                var data  = [];

                for(var idx = 0 ; idx < questions.length; idx++)
                {
                    var question = questions[idx];
                    var xmlDoc = $.parseXML(question.other);

                    var questionText = String($( xmlDoc ).find('question').text());

                    data.push({
                        translation:questionText,
                        is_correct:findExamAnswer(question.uid)
                    });
                }

                return <div>
                    <Row>
                        <Col md={12}>
                            <audio style={{width:'100%'}} src={this.cdn + this.state.examQuestion.examDataOriginal.sound + "?cacheBreaker="+new Date().getTime()} controls controlsList="nodownload"/>
                        </Col>
                    </Row>
                    <BootstrapTable data={ data || []} keyField='uid'  bordered={ true } condensed>
                        <TableHeaderColumn dataField='translation' >Question</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={this.tickbox.bind(this)} dataField='is_correct' >Correct</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            }


            if(this.props.gameUID == "203")
            {

                var questions = this.state.examQuestion.examTranslations;

                var data  = [];

                for(var idx = 0 ; idx < questions.length; idx++)
                {
                    var question = questions[idx];
                    var xmlDoc = $.parseXML(question.other);

                    var questionText = String($( xmlDoc ).find('removed').text());

                    data.push({
                        translation:questionText,
                        is_correct:findExamAnswer(question.uid)
                    });
                }

                return <div>
                    <Row>
                        <Col md={12}>
                            <div className="p-10 m-b-20" >{this.state.examQuestion.examDataOriginal.text}</div>
                        </Col>
                    </Row>
                    <BootstrapTable data={ data || []} keyField='uid'  bordered={ true } condensed>
                        <TableHeaderColumn dataField='translation' >Question</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={this.tickbox.bind(this)} dataField='is_correct' >Correct</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            }

            if(this.props.gameUID == "205")
            {
                var a = [];
                var b = [];
                var c = [];

                var questionsUID = 1;

                for(var idx = 0 ; idx < this.state.examQuestion.examTranslations.length; idx++)
                {

                    var xmlDoc = $.parseXML(this.state.examQuestion.examTranslations[idx].other);

                    $( xmlDoc ).find('personA').each(function(){
                        var color = "red";

                        if (findExamAnswer(questionsUID) == "1") {
                            color = "green";
                        }

                        a.push(<div style={{color:color}} className="b-1 m-5 p-10">{$(this).text()}{findExamAnswer(questionsUID) == "1"}</div>);
                        questionsUID++;
                    });
                    $( xmlDoc ).find('personB').each(function(){
                        var color = "red";

                        if (findExamAnswer(questionsUID) == "1") {
                            color = "green";
                        }
                        b.push(<div style={{color:color}} className="b-1 m-5 p-10">{$(this).text()}{findExamAnswer(questionsUID) == "1"}</div>);
                        questionsUID++;
                    });
                    $( xmlDoc ).find('personC').each(function(){
                        var color = "red";

                        if (findExamAnswer(questionsUID) == "1") {
                            color = "green";
                        }
                        c.push(<div style={{color:color}} className="b-1 m-5 p-10">{$(this).text()}{findExamAnswer(questionsUID) == "1"}</div>)
                        questionsUID++;
                    });

                }

                return <div className="p-20">
                    <Row>
                        <Col md={12}>
                            <audio style={{width:'100%'}} src={this.cdn + this.state.examQuestion.examDataOriginal.sound+ "?cacheBreaker="+new Date().getTime()} controls controlsList="nodownload"/>
                        </Col>
                    </Row>
                    <Row className="p-t-10 p-l-15">
                        <Col md={4}><div className="b-1 m-5 p-10">{Translation.get(12132,'Person A')}</div>{a}</Col>
                        <Col md={4}><div className="b-1 m-5 p-10">{Translation.get(12133,'Person B')}</div>{b}</Col>
                        <Col md={4}><div className="b-1 m-5 p-10">{Translation.get(12134,'Person C')}</div>{c}</Col>
                    </Row>
                </div>;
            }
        }

    }


}